/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Chat_Input_DescriptionInputs */

const es_walkthrough_chat_input_description = /** @type {(inputs: Walkthrough_Chat_Input_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acá es donde hablás con Nexy. Escribí tu pregunta o pedido y presioná Enter para enviarlo.`)
};

const en_walkthrough_chat_input_description = /** @type {(inputs: Walkthrough_Chat_Input_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is where you talk to Nexy. Type your question or request and press Enter to send it.`)
};

/**
* | output |
* | --- |
* | "This is where you talk to Nexy. Type your question or request and press Enter to send it." |
*
* @param {Walkthrough_Chat_Input_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_chat_input_description = /** @type {((inputs?: Walkthrough_Chat_Input_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Chat_Input_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_chat_input_description(inputs)
	return en_walkthrough_chat_input_description(inputs)
});
export { walkthrough_chat_input_description as "walkthrough.chat_input_description" }